import { CheckIcon, ChevronDownIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Portal,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BseDto, OrganizationInviteDto } from "../../../../../autogen/bff-api";

export const NewQuestionModal = ({
  isOpen,
  onClose,
  organizationInvites = [],
  onCreate,
}: {
  isOpen: boolean;
  onClose: () => void;
  organizationInvites?: OrganizationInviteDto[];
  onCreate: (args: { subject: string; content: string; askedToOrganizationId: string }) => Promise<BseDto>;
}) => {
  console.log("organizationInvites", organizationInvites);
  const { t } = useTranslation();
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [askedToOrgId, setAskedToOrgId] = useState<string>(() => organizationInvites[0]?.organizationId ?? "");

  useEffect(() => {
    if (organizationInvites.length === 1) {
      setAskedToOrgId(organizationInvites[0]?.organizationId ?? "");
    }
  }, [organizationInvites]);

  const handleCreate = async () => {
    if (!subject.trim() || !askedToOrgId) return;
    await onCreate({ subject, content, askedToOrganizationId: askedToOrgId });
    onClose();
    setSubject("");
    setContent("");
    setAskedToOrgId(organizationInvites[0]?.organizationId ?? "");
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("New dialog")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="6">
          <Text fontSize="sm" mb="1">
            {t("Subject")}
          </Text>
          <Input value={subject} onChange={(e) => setSubject(e.target.value)} mb="3" />
          <Text fontSize="sm" mb="1">
            {t("Ask to organization")}
          </Text>
          {organizationInvites.length === 1 ? (
            <Text fontWeight="semibold" fontSize="sm" backgroundColor="smBackgroundSecondary" rounded="md" p="2" mb="3">
              {organizationInvites[0]?.organizationName}
            </Text>
          ) : (
            <Menu size="sm" isLazy placement="bottom-start">
              <MenuButton
                as={Button}
                variant="outline"
                isDisabled={organizationInvites.length === 0}
                type="button"
                rightIcon={<ChevronDownIcon />}
                justifyContent="space-between"
                border="1px solid"
                borderColor="smBorder"
                rounded="md"
                fontWeight="normal"
                size="sm"
                mb="3"
              >
                {organizationInvites.find((o) => o.organizationId === askedToOrgId)?.organizationName ||
                  t("Select organization")}
              </MenuButton>
              <Portal>
                <MenuList overflowY="auto" zIndex={2000}>
                  {organizationInvites.map((inv) => {
                    const isSelected = askedToOrgId === inv.organizationId;
                    return (
                      <MenuItem key={inv.organizationId} onClick={() => setAskedToOrgId(inv.organizationId)}>
                        <Flex align="center" justify="space-between" width="full">
                          <Text>{inv.organizationName}</Text>
                          {isSelected ? <CheckIcon color="smPrimary" /> : null}
                        </Flex>
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </Portal>
            </Menu>
          )}
          <Text fontSize="sm" mb="1">
            {t("Question")}
          </Text>
          <Textarea value={content} onChange={(e) => setContent(e.target.value)} rows={6} />
          <Flex justifyContent="end" pt="4">
            <Button variant="outline" mr="2" onClick={onClose}>
              {t("Cancel")}
            </Button>
            <Button colorScheme="blue" onClick={handleCreate} isDisabled={!subject.trim() || !askedToOrgId}>
              {t("Create")}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
